<div class = "read-more__text">
  <span>{{display}}</span>
  <br>
    @if (!readMoreExpanded && this.continuedString.length != 0) {
      <button type="button" class="read-more__button cfa-plain-button cfa-plain-button--inline" (click)="expandReadMore($event)">Read more</button>
    }
  </div>
  @if (readMoreExpanded) {
    <div class = "read-more__text" >
      {{continuedString}}
      <button type="button" class="read-more__button cfa-plain-button cfa-plain-button--inline" (click)="collapseReadMore($event)">Read less</button>
    </div>
  }

